import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

var G2 = function G2() {
  return /*#__PURE__*/_jsx("svg", {
    width: "19",
    height: "32",
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4.85579 15.667C4.85579 18.5021 7.16485 20.8112 9.99999 20.8112C11.2307 20.811 12.4204 20.3683 13.3518 19.5637L15.2985 22.9407C13.7613 24.0657 11.905 24.6705 9.99999 24.667C5.02905 24.667 1 20.6379 1 15.667C1 10.696 5.02905 6.66699 9.99999 6.66699C10.5912 6.66691 11.181 6.72494 11.7609 6.84025L9.99999 10.5228C7.16485 10.5228 4.85579 12.8318 4.85579 15.667ZM16.652 11.9818H13.9618C14.0343 11.5596 14.2957 11.3234 14.8249 11.0556L15.3195 10.8036C16.2047 10.35 16.6772 9.83651 16.6772 8.99857C16.6772 8.4725 16.4725 8.05668 16.0661 7.75741C15.6597 7.45815 15.1809 7.31009 14.6202 7.31009C14.1864 7.30499 13.7605 7.42651 13.3948 7.65976C13.0262 7.88657 12.7521 8.17953 12.582 8.54495L13.3601 9.32619C13.6625 8.71506 14.1004 8.41579 14.6769 8.41579C15.1652 8.41579 15.4644 8.66781 15.4644 9.01747C15.4644 9.31044 15.3195 9.553 14.7588 9.83651L14.4406 9.99087C13.7507 10.3405 13.2719 10.7406 12.9947 11.1942C12.7175 11.6479 12.582 12.218 12.582 12.9079V13.0969H16.652V11.9818ZM16.2948 14.3822H11.8404L9.61328 18.238H14.0676L16.2948 22.0969L18.5219 18.238L16.2948 14.3822Z",
      fill: "#050038"
    })
  });
};

export default G2;